import { useQuery } from 'react-query';
import { fetchBuildingDetails } from '~/api/building';

export const useBuildingDetails = (buildingId: string) =>
  useQuery(
    ['buildingDetails', buildingId],
    () => fetchBuildingDetails(buildingId),
    {
      enabled: !!buildingId,
      refetchOnWindowFocus: false
    }
  );
